import { FC } from 'react'
import { Modal } from 'antd'
import shallow from 'zustand/shallow'

import { ForecastModalContent, ForecastModalHeader, useForecastModalStore, ForecastModalFooter } from '.'
import { Country } from '../../../types'
import { usePyramidsStore } from '../../../modules/pyramids/PyramidsStore'

export const ForecastModal: FC<unknown> = () => {
  const [isModalOpened] = useForecastModalStore((state) => [state.isModalOpened], shallow)
  const [companyId, country] = usePyramidsStore((state) => [state.selected.companyId, state.selected.country], shallow)

  return (
    <Modal
      title={<ForecastModalHeader />}
      visible={isModalOpened}
      closable={false}
      footer={<ForecastModalFooter companyId={companyId} country={country as Country} />}
      destroyOnClose={true}
      className="per-modal per-modal--xxlarge"
    >
      <ForecastModalContent companyId={companyId} country={country as Country} />
    </Modal>
  )
}
